import { render } from "./Game.vue?vue&type=template&id=1e551286&scoped=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=1e551286&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e551286"

export default script